module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container logged-out-content"
  }, [_c('form', {
    staticClass: "block form-sm",
    attrs: {
      "name": "forgotUsernameForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.requestUsernameReminder()
      }
    }
  }, [_vm._m(0), _vm._v(" "), (!_vm.requestComplete) ? _c('div', {
    staticClass: "subheader"
  }, [_c('p', [_vm._v("Please enter your email address below")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (!_vm.requestComplete) ? _c('div', [(_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    attrs: {
      "name": "email",
      "label": "Email Address",
      "validation": _vm.$v.emailAddress
    },
    model: {
      value: (_vm.emailAddress),
      callback: function($$v) {
        _vm.emailAddress = $$v
      },
      expression: "emailAddress"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "col-xs-12 pointer text-center"
  }, [_c('submit-button', {
    attrs: {
      "id": "request-username-reminder-submit",
      "loading": _vm.loading
    }
  }, [_vm._v("Request Reminder")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.requestComplete) ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("If a user with this email address exists, then an email will be sent to their registered email address with a username\n        reminder")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/Patient-Icon.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('h2', [_vm._v("Forgotten Username")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "glyphicon glyphicon-asterisk"
  }), _vm._v(" indicates a required field")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adec7cb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/ForgotUsername.vue
// module id = 672
// module chunks = 5